<template>
  <v-form v-model="isValid" ref="form" v-bind="this.$attrs" style="width: 100%">
    <div v-if="isEditable">
      <div class="section-label py-6">Diện tuyển thẳng</div>
      <div class="d-flex">
        <v-checkbox class="align-self-start mt-0 pt-0" v-model="isRecuitingStraight"></v-checkbox>
        <div class="text-justify">
          Con của tôi đạt đủ 1 trong 2 tiêu chí và nằm trong diện tuyển thẳng của nhà trường.
        </div>
      </div>
      <v-row no-gutters>
        <v-radio-group v-model="studyResult.recuitingStraightType">
          <v-radio v-for="item in recuitingStraightTypes" :key="item.value" :label="item.value" :value="item.value" />
        </v-radio-group>
      </v-row>
      <div class="field-label mb-2">
        <span class="error--text">(*)</span> Phụ huynh vui lòng đến cơ sở của Nhà trường để xác nhận với ban tuyển sinh
        về diện tuyển thẳng của con khi làm thủ tục nhập học
      </div>
    </div>
    <div v-else>
      <div class="section-label py-6">Diện tuyển thẳng</div>
      <div v-if="isRecuitingStraight">
        <div>Con của tôi đạt tiêu chí dưới và nằm trong diện tuyển thẳng của nhà trường.</div>
        <div class="font-weight-bold">"{{ $get(studyResult, 'recuitingStraightType', 'Chưa có thông tin') }}"</div>
      </div>
      <div class="d-flex text-justify" v-else>Con của tôi không nằm trong diện tuyển thẳng của nhà trường.</div>
      <div class="field-label py-6">
        <span class="error--text">(*)</span> Phụ huynh vui lòng đến cơ sở của Nhà trường để xác nhận với ban tuyển sinh
        về diện tuyển thẳng của con khi làm thủ tục nhập học
      </div>
    </div>
  </v-form>
</template>

<script>
export default {
  props: {
    documentStep: Number,
    document: {type: Object, default: () => {}},
    isEditing: Boolean,
    currentStep: {type: Number, default: 5},
  },
  watch: {
    isRecuitingStraight(newValue) {
      if (!newValue) this.studyResult.recuitingStraightType = ''
    },
  },
  computed: {
    isEditable() {
      return this.documentStep === this.currentStep || this.isEditing
    },
    isNotEditable() {
      return this.documentStep !== this.currentStep && !this.isEditing
    },
  },
  data() {
    return {
      isValid: false,
      isRecuitingStraight: false,
      studyResult: {recuitingStraightType: ''},
      recuitingStraightTypes: [
        {value: 'Học sinh không thuộc diện tuyển thẳng.'},
        {
          value:
            'Học sinh đạt giải Nhất, Nhì hoặc Ba một trong các môn: Toán, KHTN, Ngữ Văn hoặc Tiếng Anh trong kỳ thi học sinh giỏi cấp Tỉnh, Thành phố.',
        },
      ],
    }
  },
  created() {
    if (this.document.studyRecord) {
      const _studyRecord = {...this.document.studyRecord}
      Object.keys(_studyRecord).forEach(key => {
        if (key.startsWith('grade')) {
          this.studyResult[key] = _studyRecord[key].replace(',', '.')
        } else {
          this.studyResult[key] = _studyRecord[key]
        }
      })
      this.isRecuitingStraight = this.document.studyRecord.recuitingStraightType != ''
    }
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    reset() {
      this.$refs.form.reset()
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
    getData() {
      return {studyResult: this.studyResult}
    },
  },
}
</script>

<style scoped>
.field-label {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: #797979;
  margin-bottom: 4px;
}
.section-label {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: #3e3e3c;
}
hr.dashed {
  width: 100%;
  border: 1px dashed #e6e4eb;
}
</style>
